import { Input } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import styled from 'styled-components';

import { sizeUp } from '~/theme';

export const ZipCodeInput = styled(Input.Search)(({ theme }) => ({
  width: '208rem',

  '& .ant-input-group': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    height: '41rem',
    paddingInlineStart: '10rem',
    border: `1rem solid ${theme.page.input.borderColor}`,
    borderRadius: '4rem',
    boxShadow: `inset 0rem 3rem 6rem ${theme.palette.black}29`,
  },

  '& .ant-input': {
    padding: 0,
    border: 'none',
    boxShadow: 'none',

    fontSize: theme.typography.size16,
  },

  '& .ant-input-group-addon': {
    width: 'auto',

    backgroundColor: 'transparent',
  },

  '& .ant-btn-primary': {
    backgroundColor: 'inherit',
    color: theme.page.primary.text,
    border: 'none',
    boxShadow: 'none',

    outlineColor: `${theme.palette.desertSand} !important`,
  },

  '& .ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover': {
    backgroundColor: 'inherit',
    color: theme.page.primary.text,
  },

  '& .ant-btn-icon': {
    paddingTop: '4rem',

    fontSize: '20rem',
    color: theme.palette.darkLiver,
  },
}));

export const SubmitContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const SubmitFormItem = styled(FormItem)(({ theme }) => ({
  fontSize: '16rem',
  color: theme.defaultTheme.textColor,
  height: '24rem',
  marginBottom: sizeUp('0rem', ['md', '24rem']),
}));

export const Text = styled.div({
  textAlign: 'center',
});
